<template>
  <div>

      <CCol md="12">
        <CCard>
          <CCardHeader>
            <strong>{{ $t('ReceiptsAndPayments') }}</strong>
          </CCardHeader>
          <CCardBody>
            <CDataTable
                :items="items"
                :fields="fields"

                :items-per-page="20"
                hover
                sorter
                pagination
            >
              <template #row="{item}">

                <td style="text-align: center">
                  <p >{{ item.row_id + 1 }}</p>

                </td>

              </template>
              <template #name="{item}">

                <td>
                  <p >{{ item.title }}</p>

                </td>

              </template>

              <template #summary="{item}">

                <td>
                  <p v-if="item.summary != 'null'">{{ item.summary }}</p>

                </td>

              </template>
              <template #docDate="{item}">
                <td>
                  <p >{{ get_date(item.docDate) }}</p>
                </td>
              </template>

              <template #amount="{item}">

                <td>
                    <p >{{item.amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g,
                        ",")}} </p>
                </td>
              </template>

              <template #operation="{item}">
                <td >

                  <CButton v-if="item.statusType ==0"
                      class="m-1"
                      color="warning"
                      variant="outline"
                      square
                      size="sm"
                      :title="$t('buttons.delete')"
                      @click="edit_item(item)"
                  >
                    <CIcon name="cilPencil"/>
                  </CButton>
                  <CButton v-if="item.statusType ==0"
                      class="m-1"
                      color="danger"
                      variant="outline"
                      square
                      size="sm"
                      :title="$t('buttons.delete')"
                      @click="delete_item_dialog(item)"
                  >
                    <CIcon name="cilTrash"/>
                  </CButton>
                  <CButton v-if="item.statusType ==0"
                           class="m-1"
                           color="primary"
                           square
                           size="sm"
                           :title="$t('buttons.finalize')"
                           @click="Finalize(item)"
                  >
                    <CIcon name="cil-https"/>
                  </CButton>
                </td>
              </template>


            </CDataTable>
          </CCardBody>
          <CCardFooter>

          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
// import the styles
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
var simulateAsync=null
const simulateAsyncOperation = fn => {
  if(simulateAsync!=null){
    clearTimeout(simulateAsync)
  }
  simulateAsync =  setTimeout(fn, 1000)
}
var items = [];


export default {
  name: 'Login',
  components: {
    Treeselect,
  },
  data() {
    return {
      confirm_delete_name:"confirm"+new Date().getTime()+"_"+this.$vnode.tag,

      validate_errors: [],
      selected_level: '',


      items: items.map((item, row_id) => {
        return {...item, row_id}
      }),
      fields: [
        {key: 'row', label: this.$t('tables.row'),sorter:false, _style: 'width:10%'},
        {key: 'docDate', label: this.$t('tables.date'), _style: 'width:10%'},
        {key: 'docNumber', label: this.$t('docNumber'), _style: 'width:10%'},
        {key: 'docType', label: this.$t('components.docType'), _style: 'width:10%'},
        {key: 'docType', label: this.$t('components.docType'), _style: 'width:10%'},
        {key: 'referenceNo', label: this.$t('referenceNo'), _style: 'width:10%'},
        {key: 'PayerRecipient', label: this.$t('PayerRecipient'), _style: 'width:10%'},
        {key: 'bedehkar', label: this.$t('bedehkar'), _style: 'width:10%'},
        {key: 'bestankar', label: this.$t('bestankar'), _style: 'width:10%'},
        {key: 'balance', label: this.$t('tables.balance'), _style: 'width:10%'},
        {key: 'accountTypeTitle', label: this.$t('tables.type'), _style: 'width:10%'},
        {key: 'paymentTypeTitle', label: this.$t('tables.name'), _style: 'width:10%'},
        {key: 'cashierName', label: this.$t('tables.payer'), _style: 'width:10%'},

        {key: 'partyName', label: this.$t('tables.customer'), _style: 'width:10%'},
        {key: 'amount', label: this.$t('tables.amount'), _style: 'width:10%'},

        {key: 'operation', label: this.$t('tables.operation'), _style: 'width:20%;'},
      ],

      status_form: 0,

      searched_person:[],
      document_person: null,
      search_user_async :true,
      load_persons({action, searchQuery, callback}) {

        if (action === ASYNC_SEARCH) {
          simulateAsyncOperation(() => {
            let options;
            const formData = new FormData();

            formData.append('SearchTxt', searchQuery);

            axios.post('GetUsers', formData, {show_pros:true}).then(function (response) {
              options = response.data.data;

              callback(null, options);

              // localStorage.setItem("api_token", response.data.access_token);
              // self.$router.push({ path: 'notes' });
            })
                .catch(function (error) {
                  console.log(error);
                });
          })
        }
      },
      normalizer_persons(node) {
        return {
          id: node.userId,
          label: node.personCode +" "+ node.userName +" "+ node.surName+" "+ node.mobileNo,
        }
      },

    }
  },
  created() {
  },
  mounted() {
    this.$root.root_validate_errors = [];

    this.get_lists();
    bus.$on('delete_cash_confirm', (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {
    '$route.params.cat_id': function () {
      this.get_lists();
    },

  },
  methods: {

    Finalize(item) {
      var self = this;


      const formData = new FormData();

      var url = "AddCashPaymentToFinal";

      formData.append("id", item.recId);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        self.$root.modal_component.show_api_response_modals(response);

        if (content_data.statusCode == 0) {
          item.statusType = 1;
        } else {
          // self.$root.modal_component.show_danger_modal('خطا', content_data.message);

        }

      })
          .catch(function (error) {
            console.log(error);
          });

    },
    validateForm: function () {
      this.$root.root_validate_errors = [];

      if (this.document_person != null && this.selected_level != '') {
        return true;
      }


      if (this.document_person == null) {
        this.$root.root_validate_errors.push(this.$t('dialogs.selectUser'));
      }
      if (this.selected_level == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertLevel'));
      }

      return false;
      // e.preventDefault();
    },

    edit_item(item) {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)

      this.selected_level = item.levelNo;
   this.search_user_async =false;

      this.searched_person = [{
        userId: item.personId,
        userName: item.personName,
      }];
      this.document_person = item.personId;
      this.search_user_async =false;

      this.status_form = item.recId;
      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },

    get_lists() {
      var self = this;

      const formData = new FormData();


      // formData.append('Id', this.$route.params.group_id);


      axios.post('GetCashPaymentList', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          content_data.data.reverse()

          self.items = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    goToMembers(item) {

      this.$router.push({path: '/dashboard/accounting/sale-method-members/' + item.id});

    },

    insert_data() {

      if (!this.validateForm()) {
        console.log("validate form is false" + this.validate_errors);
        return true;
      }
      let self = this;
      const formData = new FormData();
      let url;
      if (this.status_form == 0) {
        url = "AddAccountTafsili";
      } else {
        url = "EditAccountTafsili";
        formData.append('Id', this.status_form)

      }



      formData.append('AccountId', this.$route.params.group_id);
      formData.append('PersonId', this.document_person);
      formData.append('LevelNo', this.selected_level);

      // formData.append('AreaId', this.selected_area);
      axios.post(url, formData, {}).then((res) => {


        self.status_form = 0;

        self.document_person = null;
        self.selected_level = '';

        self.get_lists();

        self.$root.modal_component.show_api_response_modals(res);

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    delete_item_dialog(item) {

      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], 'delete_cash_confirm');

      this.status_form = item.recId;

    }, delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "DeleteCashPayment";


      formData.append('Id', this.status_form);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;

        self.get_lists();


      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
  }
}

</script>
